import { __assign, __rest } from "tslib";
import React from 'react';
import { Select, Tag, Tooltip } from '@hose/eui';
import { getTagLabel } from '../../util';
export var TagShow = function (_a) {
    var tags = _a.tags, disabled = _a.disabled, tagLabelLimit = _a.tagLabelLimit, onClick = _a.onClick, props = __rest(_a, ["tags", "disabled", "tagLabelLimit", "onClick"]);
    var maxTagCountPlaceholder;
    if (props.showMaxTagCountTooltip && (props === null || props === void 0 ? void 0 : props.maxTagCount) > 0 && (tags === null || tags === void 0 ? void 0 : tags.length) > props.maxTagCount) {
        var tooltipStr_1 = [];
        tags === null || tags === void 0 ? void 0 : tags.forEach(function (item, index) {
            if (index >= props.maxTagCount) {
                tooltipStr_1.push((item === null || item === void 0 ? void 0 : item.label) || (item === null || item === void 0 ? void 0 : item.name));
            }
        });
        maxTagCountPlaceholder = React.createElement(Tooltip, { title: tooltipStr_1.join(',') }, "+" + (tags.length - props.maxTagCount));
    }
    return (React.createElement(TagSelect, __assign({}, props, { open: false, showSearch: false, value: tags.map(function (item) { return item.id; }), tagRender: function (item) { return tagRender(item, tags, disabled, tagLabelLimit); }, onClick: !disabled ? onClick : undefined, maxTagPlaceholder: maxTagCountPlaceholder })));
};
var tagRender = function (item, tags, disabled, tagLabelLimit) {
    if (tagLabelLimit === void 0) { tagLabelLimit = function (tag) { return ({ toolTipStr: '', tag: tag }); }; }
    var tag = tags.find(function (o) { return o.id === item.value; });
    var value = item.value, closable = item.closable, onClose = item.onClose;
    var _a = tagLabelLimit(tag), toolTipStr = _a.toolTipStr, showTag = _a.tag;
    var tagContent = function (show) { return (React.createElement("span", { style: value !== 'departmentsIncludeChildren' ? { color: 'var(--eui-text-title)' } : {} }, getTagLabel(show, tag.showAvatar, {
        style: {
            marginRight: 4,
            width: 16,
            height: 16,
            lineHeight: '16px',
            marginBottom: 2,
            border: '1px solid var(--eui-static-white)'
        }
    }))); };
    return (React.createElement(Tag, __assign({ key: value, closable: closable && !disabled, onClose: onClose, style: { marginRight: 3, marginBottom: 1.5, marginTop: 1.5 } }, tag.tagOptions), !!toolTipStr ? React.createElement(Tooltip, { title: toolTipStr }, tagContent(showTag)) : tagContent(tag)));
};
export var TagSelect = function (_a) {
    var placeholder = _a.placeholder, children = _a.children, others = __rest(_a, ["placeholder", "children"]);
    return (React.createElement(Select, __assign({ placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : i18n.get('请选择'), mode: "tags", showArrow: true, style: { width: '100%', overflowY: 'auto' }, onFocus: function (e) { return e.target.blur(); } }, others), children));
};
export default TagShow;
